import React, {Component} from 'react';
import { adminloadTP, AuthenticatedUser, stopTimer } from "../../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from '../tournamentPageTemplate'

class TournamentAdminBallots extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.getTdProps = this.getTdProps.bind(this);


        this.state = {
            loading: true,
            open: false,
            user: user,
            tData: {},
            pid: params.pid,
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            adminloadTP('ballots', 'f', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({tData: d2.tournamentPage, ballots: d2.ballots, loading: false});                    

                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    getJudgeStatusColor(status) {
        switch(status.substring(0,3)) {
            case "Rea": return "font-success"
            case "Ava": return "font-warning"
            case "Set": return "font-danger"
            default: return "font-info"
        }
    }

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row && column.id !== "delete") {
            return {
                onClick: () => { 
                    const roomId = rowInfo.original.roomId;
                    const judgeId = rowInfo.original.judge.userId;
                    this.props.history.push(`/tournament/ballot/room/judge/${this.state.tData._id}/${roomId}/${judgeId}`)
                },
                onMouseOver: (e) => {
                    this.setState({
                        selected: rowInfo.index
                    })
                },
                style: {
                    background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                    //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                }
            }
        } else { return {} }
    }
        
    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, user, ballots } = this.state;
            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Ballot List - ${user.displayname}`} title3=""
                bcTitle="Ballot List" bcParents={[
                    {name: tData.title, url: `/pages/tournament/${tData._id}`},
                    {name: "Administration", url: `/tournament/admin/${tData._id}`}
                ]}
            >              
                <div className="container-fluid">           
                    <div className="row">
                        <div className="col-sm-12">
                            <ReactTable
                                filterable
                                defaultFilterMethod={ (filter, row, column) => {
                                    const id = filter.pivotId || filter.id
                                    return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                }}
                                data={ballots}
                                columns={[{
                                    Header: 'Submitted?',
                                    accessor: 'isSubmitted',
                                    style: { textAlign: 'center'},
                                    maxWidth: 100,                                   
                                    Cell: (row) => {
                                        return (
                                           <input
                                               type='checkbox'
                                               id={'iss'+row.original.ballotId}
                                               checked={row.original.isSubmitted}
                                               style={{zoom: "1.2", width: "20px", height: "20px"}}
                                           />                                          
                                        )}
                                },{
                                    Header: 'Round',
                                    accessor: 'round',
                                },{
                                    Header: 'Event',
                                    accessor: 'event',
                                },{
                                    Header: 'Room',
                                    accessor: 'room',
                                },{
                                    Header: 'Judge',
                                    accessor: 'judge.displayname',
                                },{
                                    Header: 'Phone',
                                    accessor: 'judge.phone',
                                }]}                                        
                                defaultPageSize={32}
                                showPagination={true}  
                                getTdProps={this.getTdProps}                                                                                                     
                            />
                        </div>
                    </div>  
                </div>
                          
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentAdminBallots;